frappe.ui.form.ControlAbsFloat = class ControlAbsFloat extends frappe.ui.form.ControlFloat {
    make_input() {
        super.make_input();

        var me = this;

        // Ensure the field always displays a positive number when focused
        this.$input.on("focus", function () {
            setTimeout(function () {
                if (!document.activeElement) return;
                // Always show the absolute value on focus
                document.activeElement.value = Math.abs(me.validate(document.activeElement.value));
                document.activeElement.select();
            }, 100);
            return false;
        });

        this.$input.on("focusout", (e) => {
            let value = this.get_input_value();
            this.parse_validate_and_set_in_model(value, e);
            this.refresh();
        });
    }

    validate(value) {
        return this.parse(value);
    }

    parse(value) {
        value = this.eval_expression(value);
        let parsed_value = isNaN(parseFloat(value)) ? null : flt(value, this.get_precision());
        return parsed_value ? -Math.abs(parsed_value) : 0;  // Always store as negative
    }

    format_for_input(value) {
        if (!value) return "";

        var number_format;
        if (this.df.fieldtype === "AbsFloat" && this.df.options && this.df.options.trim()) {
            number_format = this.get_number_format();
        }

        var formatted_value = format_number(Math.abs(value), number_format, this.get_precision()); // Show positive
        return formatted_value;
    }

    format(value) {
        // Ensure the UI always displays a positive value in grid view
        return value == null || value === "" ? "" : format_number(Math.abs(value), this.get_number_format(), this.get_precision());
    }

    get_number_format() {
        var currency = frappe.meta.get_field_currency(this.df, this.get_doc());
        return get_number_format(currency);
    }

    get_precision() {
        // Round based on field precision or float precision, else don't round
        return this.df.precision || cint(frappe.boot.sysdefaults.float_precision, null);
    }
};

// Register the new control field
frappe.ui.form.ControlNegativeFloat = frappe.ui.form.ControlAbsFloat;
